import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import "./style.scss";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.scss";
import VideoDetail from "./VideoDetail";
import { Link, BrowserRouter as Router, Route } from "react-router-dom";
import { formDataGenerator, getRouting, getYoutubePosterImage } from "../../../../../utils/common";
import { getInvestorMarket } from "../actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

const InvestorMarketUpdate = (props) => {
  const {
    getInvestorMarket,
    MarketData,
    location: { pathname },
  } = props;

  const getCurrent = (nc) => {
    switch (nc) {
      case "documents":
        return 0;
      case "videos":
        return 1;
      default:
        return 0;
    }
  };
  const current = pathname.split("/")[3];
  const [investorMarket, setinvestorMarket] = useState();
  // const [videoData, setvideoData] = useState();
  const [selectedIndexTab, setSelectedIndexTab] = useState(getCurrent(current));
  const [currentPageurl, setCurrentPageurl] = useState("documents");
  const [docSearch, setdocSearch] = useState("");
  const [documentYear, setdocumentYear] = useState("");
  const [metaData, setMetaData] = useState();
  const [flag , setFlag] = useState(false);

  useEffect(() => {
    if (current) {
      setCurrentPageurl(current);
    }
  }, [current]);

  useEffect(()=>{
    if(flag == true){
      setFlag(false);
    }
  },[flag]);

  // useEffect(() => {
  //   if (currentPageurl == "documents") {
  //     investorFormList();
  //   }
  //   if (currentPageurl == "Videos") {
  //     noticesAgendaList();
  //   }
  // }, [currentPageurl]);

  useEffect(() => {
    if (currentPageurl === "documents") {
      setSelectedIndexTab(0);
    }
    if (currentPageurl === "videos") {
      setSelectedIndexTab(1);
    }
  }, [currentPageurl]);

  useEffect(() => {
    let urlName = "";
    let formData = {};
    if (current === "documents") {
      urlName = "data";
      formData = {
        search: docSearch ? docSearch : "",
        year: documentYear ? documentYear : '',
      };
    } else {
      urlName = "videos";
    }
    !(MarketData && MarketData.investormarket && flag == false) &&
    getInvestorMarket({},formDataGenerator(formData), urlName);
  }, [current, docSearch, documentYear]);

  useEffect(() => {
    if (MarketData && MarketData.investormarket) {
      setinvestorMarket(MarketData.investormarket);
    }

    if (MarketData && MarketData.investormarket && MarketData.investormarket.meta) {
      setMetaData(MarketData.investormarket.meta);
    }
  });

  const handleApiCall = async (e, tabName) => {
    setCurrentPageurl(tabName);
    setdocSearch("");
    setFlag(true);
    if (currentPageurl === "videos") {
      setdocumentYear("");
    }
  };

  const handledocumentSearch = (e) => {
    setdocSearch(e.target.value);
    setFlag(true);
  };
  const handleDocumentSelect = (e) => {
    setdocumentYear(e.target.value);
    setFlag(true);
  };

  return (
    <>
      <div className="wrapper">
        {
          metaData ? (
            <Helmet>
              <title>{metaData && metaData.title ? metaData.title : ""}</title>
              <meta name="description"
                content={
                  metaData && metaData.description ? metaData.description : ""
                }
              />
              <meta name="keywords"
                content={
                  metaData && metaData.keywords ? metaData.keywords : ""
                }
              />
              <meta property="og:title"
                content={
                  metaData && metaData.og_title ? metaData.og_title : ""
                }
              />
              <meta property="og:description"
                content={
                  metaData && metaData.og_description ? metaData.og_description : ""
                }
              />
              <meta property="og:image"
                content={
                  metaData && metaData.og_image ? metaData.og_image : ""
                }
              />
              <meta property="og:url"
                content={
                  metaData && metaData.og_url ? metaData.og_url : ""
                }
              />
            </Helmet>
          ) : ("")
        }
        <section className="aboutHead">
          <div className="container">
            <div className="d-flex">
              <h1 className="me-auto">
                <span>Market </span>Update
              </h1>
              <nav
                aria-label="breadcrumb"
                className="align-self-center breadCrumbCust d-md-inline"
              >
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/investor-services">Investor Services</a>
                  </li>
                  <li
                    className="breadcrumb-item active breadcolor"
                    aria-current="page"
                  >
                    Market Update
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </section>
        <section>
          <div className="container">
            <Tabs
              className="customTab"
              selectedIndex={selectedIndexTab}
            >
              <TabList>
                <Link
                  to={getRouting(
                    "/investor-services/market-update/documents",
                    "Documents"
                  )}
                >
                  <Tab
                    onClick={async (e) => await handleApiCall(e, "documents")}
                    tabFor="0"
                    value={0}
                  >
                    <div>
                      <p>Documents</p>
                    </div>
                  </Tab>
                </Link>
                <Link
                  to={getRouting(
                    "/investor-services/market-update/videos",
                    "Videos"
                  )}
                >
                  <Tab
                    onClick={async (e) => await handleApiCall(e, "videos")}
                    tabFor="1"
                    value={1}
                  >
                    <div>
                      <p>Videos</p>
                    </div>
                  </Tab>
                </Link>
              </TabList>
              <TabPanel>
                <div className="forms mt-4">
                  <p className="title mb-3">
                    Select the Financial Year to View Reports
                  </p>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="row mb-4">
                        <div className="col-md-6">
                          <div className="input-group inputt">
                            <select
                              className="form-select"
                              onChange={handleDocumentSelect}
                            >
                              {investorMarket &&
                                investorMarket.Years &&
                                investorMarket.Years.values &&
                                Object.keys(investorMarket.Years.values)
                                  .length > 0 &&
                                Object.keys(investorMarket.Years.values).map(
                                  (year, index) => (
                                    <option value={year}>
                                      {
                                        Object.values(
                                          investorMarket.Years.values
                                        )[index]
                                      }
                                    </option>
                                  )
                                )}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-group iggroup mb-3">
                            <span className="input-group-text serchcolor">
                              <img
                                className="search"
                                src="/images/New/grey-search.svg"
                                alt="search"
                              />
                            </span>
                            <input
                              type="text"
                              className="form-control ps-0 p-2"
                              aria-label="Sizing example input"
                              aria-describedby="inputGroup-sizing-default"
                              placeholder="Search.."
                              onChange={handledocumentSearch}
                              value={docSearch}
                            />
                            
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    {investorMarket &&
                      investorMarket.data &&
                      investorMarket.data.length > 0 &&
                      investorMarket.data.map((item, index) => (
                        <a
                          href={item.file && item.file.url ? item.file.url : ""}
                          target="__blank"
                        >
                          <div className="bgw d-flex justify-content-between align-items-center p-4 mb-3">
                            <div className="d-flex align-items-center">
                              <img src="/images/New/pdf.png" />
                              <h2 className="ms-2 texts">
                                {item.title ? item.title : ""}
                              </h2>
                            </div>
                            <div className="d-flex justify-content-end sidearrow">
                              <img src="/images/New/redarrow.svg" />
                            </div>
                          </div>
                        </a>
                      ))}
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
                <div className="learnerscorner mt-5">
                  <div className="row">
                    {investorMarket &&
                      investorMarket.data &&
                      investorMarket.data.length > 0 &&
                      investorMarket.data.map((video, index) => {
                        const posterImage = getYoutubePosterImage(video.youtubeId);
                        return (
                          <div className="col-md-4" key={index}>
                            <div className="card">
                              <a
                                href={`/investor-services/market-update/videos/${video.suggestedUrl}`
                                }
                              >
                                <div className="mainvideo">
                                {video.thumbnail && video.thumbnail.url || posterImage ? (
                                  <img
                                    className="card-img-top img-fluid w-100"
                                    src={ video.thumbnail && 
                                      video.thumbnail.url ? video.thumbnail.url : posterImage
                                    }
                                    alt={
                                      video &&
                                      video.thumbnail &&
                                      video.thumbnail.alt ? video.thumbnail.alt : "mdVid"
                                    }
                                  />
                                  ) : (
                                    <img
                                      className="card-img-top img-fluid w-100"
                                      src="/images/New/learnNew/articlesimg.svg"
                                      alt="mdVid"
                                    />
                                  )}
                                  <img
                                    src="/images/New/learnNew/you-tube-play-icon.png"
                                    className="playicon"
                                  />
                                  {video && video.videoDuration ? <div className="readcls">{video.videoDuration}</div> : ""}
                                  {/* <div className="readcls">11:11</div> */}
                                </div>
                              </a>
                              <div className="card-body px-0">
                                <a
                                  href={
                                    `/investor-services/market-update/videos/${video.suggestedUrl}`
                                  }
                                >
                                  <div className="card-title mb-0">
                                    {video.title ? video.title : ""}
                                  </div>
                                </a>
                                <p className="card-text">
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: video.description,
                                    }}
                                  />
                                </p>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </TabPanel>
            </Tabs>
          </div>
        </section>
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  MarketData: state.InvesterServices,
});

const mapDispatchToProps = (dispatch) => ({
  getInvestorMarket: bindActionCreators(getInvestorMarket, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InvestorMarketUpdate);
